"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WrapChildrenInMobileLayout = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _auxiliaryButtons = _interopRequireDefault(require("./auxiliary-buttons"));
var _rule = _interopRequireDefault(require("../../rule"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var WrapChildrenInMobileLayout = exports.WrapChildrenInMobileLayout = function WrapChildrenInMobileLayout(_ref) {
  var accountNav = _ref.accountNav,
    children = _ref.children,
    closeHamburgerNav = _ref.closeHamburgerNav,
    isUserAuthenticated = _ref.isUserAuthenticated,
    layout = _ref.layout;
  if (layout === 'mobile') {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (!accountNav || !isUserAuthenticated) && /*#__PURE__*/_react["default"].createElement(_rule["default"], {
      className: "pt3 pb5 px5"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "inline-block px4",
      onClick: closeHamburgerNav
    }, children));
  }
  return children;
};
var AuxiliaryNav = function AuxiliaryNav(_ref2) {
  var accountButton = _ref2.accountButton,
    accountNav = _ref2.accountNav,
    AuxiliaryContent = _ref2.auxiliaryContent,
    closeHamburgerNav = _ref2.closeHamburgerNav,
    findAStorePin = _ref2.findAStorePin,
    isUserAuthenticated = _ref2.isUserAuthenticated,
    joinNowButton = _ref2.joinNowButton,
    layout = _ref2.layout,
    signInButton = _ref2.signInButton,
    signOutButton = _ref2.signOutButton,
    useCrateLayout = _ref2.useCrateLayout,
    useMaxWidthLayout = _ref2.useMaxWidthLayout;
  var noButtonsProvided = !accountNav && !accountButton && !findAStorePin && !joinNowButton && !signInButton && !signOutButton;
  if (noButtonsProvided && !AuxiliaryContent) {
    return null;
  }
  var getComponent = function getComponent() {
    if (AuxiliaryContent) {
      // if the consumer provides an AuxiliaryContent component, we render that
      // instead of any of the prescripted buttons, even if button props are provided.
      return /*#__PURE__*/_react["default"].createElement(AuxiliaryContent, null);
    }
    return /*#__PURE__*/_react["default"].createElement(_auxiliaryButtons["default"], {
      accountButton: accountButton,
      accountNav: accountNav,
      findAStorePin: findAStorePin,
      isUserAuthenticated: isUserAuthenticated,
      joinNowButton: joinNowButton,
      layout: layout,
      signInButton: signInButton,
      signOutButton: signOutButton,
      useCrateLayout: useCrateLayout,
      useMaxWidthLayout: useMaxWidthLayout
    });
  };
  return /*#__PURE__*/_react["default"].createElement(WrapChildrenInMobileLayout, {
    accountNav: accountNav,
    closeHamburgerNav: closeHamburgerNav,
    isUserAuthenticated: isUserAuthenticated,
    layout: layout
  }, getComponent());
};
AuxiliaryNav.propTypes = process.env.NODE_ENV !== "production" ? {
  accountButton: _propTypes["default"].object,
  accountNav: _propTypes["default"].object,
  auxiliaryContent: _propTypes["default"].elementType,
  closeHamburgerNav: _propTypes["default"].func,
  findAStorePin: _propTypes["default"].object,
  isUserAuthenticated: _propTypes["default"].bool,
  joinNowButton: _propTypes["default"].object,
  layout: _propTypes["default"].oneOf(['desktop', 'mobile']),
  signInButton: _propTypes["default"].object,
  signOutButton: _propTypes["default"].object,
  useCrateLayout: _propTypes["default"].bool
} : {};
var _default = exports["default"] = AuxiliaryNav;